import axios from 'axios';
import { getAuthHeader, getAuthToken, getUsername } from './authService';
import { getApiUrl } from '../utils/config';

interface UpdateUserData {
  email?: string;
  firstName?: string;
  lastName?: string;
  profileImageUrl?: string;
  gender?: string | null;
}

export interface UserProfile {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  profileImageUrl: string;
  gender: string | null;
  role: string;
  active: boolean;
  stravaAthleteId: number | null;
  hasStravaToken: boolean;
  createdAt: number[];
  updatedAt: number[];
}

export const getUserProfile = async (username: string | null): Promise<UserProfile> => {
  try {
    const currentUsername = username || getUsername();
    console.log('Current username:', currentUsername);
    if (!currentUsername) {
      throw new Error('Không tìm thấy tên người dùng. Vui lòng đăng nhập lại.');
    }

    const authHeader = getAuthHeader();
    console.log('Auth header:', authHeader);
    
    const apiUrl = `${getApiUrl()}/api/users/me?username=${currentUsername}`;
    console.log('Gọi API:', apiUrl);

    const response = await axios.get(
      apiUrl,
      {
        headers: {
          'Authorization': authHeader,
        }
      }
    );

    console.log('API response:', response.data);

    if (response.data.result === 'SUCCESS') {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Không thể lấy thông tin người dùng');
    }
  } catch (error: any) {
    console.error('Lỗi chi tiết khi lấy thông tin người dùng:', error);
    if (error.response) {
      console.error('Mã lỗi:', error.response.status);
      console.error('Dữ liệu lỗi:', error.response.data);
      const errorMessage = error.response.data.message || 'Lỗi khi lấy thông tin người dùng';
      throw new Error(errorMessage);
    }
    throw error;
  }
};

export const updateUserInfo = async (userId: number, userData: UpdateUserData): Promise<any> => {
  try {
    const token = getAuthToken();
    
    if (!token) {
      throw new Error('Không tìm thấy token xác thực. Vui lòng đăng nhập lại.');
    }
    
    console.log('Dữ liệu cập nhật:', userData); // Log dữ liệu trước khi gửi
    
    const response = await axios.put(
      `${getApiUrl()}/api/users/${userId}`,
      userData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response.data;
  } catch (error: any) {
    if (error.response) {
      // Lỗi từ server
      const errorMessage = error.response.data.message || 'Lỗi khi cập nhật thông tin người dùng';
      throw new Error(errorMessage);
    }
    
    // Lỗi khác
    throw error;
  }
};

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const changePassword = async (data: ChangePasswordRequest): Promise<any> => {
  try {
    const token = getAuthToken();
    
    if (!token) {
      throw new Error('Không tìm thấy token xác thực. Vui lòng đăng nhập lại.');
    }
    
    const response = await axios.post(
      `${getApiUrl()}/api/users/change-password`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const errorMessage = error.response.data.message || 'Lỗi khi đổi mật khẩu';
      throw new Error(errorMessage);
    }
    throw error;
  }
}; 